/**
 * Estado vazio para Histórico
 */

import React from "react";
import { FileText, Search } from "lucide-react";
import type { TimelineSourceFilter } from "../../../types/historico";
import { getSourceLabel } from "../../../utils/historicoNormalizer";

interface HistoricoEmptyStateProps {
	searchTerm?: string;
	sourceFilter?: TimelineSourceFilter;
}

export function HistoricoEmptyState({
	searchTerm,
	sourceFilter,
}: HistoricoEmptyStateProps) {
	const hasFilters = searchTerm || (sourceFilter && sourceFilter !== "all");
	const sourceLabel =
		sourceFilter && sourceFilter !== "all"
			? getSourceLabel(sourceFilter)
			: "";

	return (
		<div className="flex items-center justify-center h-full p-8">
			<div className="text-center text-gray-400">
				{hasFilters ? (
					<>
						<Search className="w-12 h-12 mx-auto mb-4 opacity-50" />
						<p className="text-sm font-medium mb-2">
							Nenhum item encontrado
						</p>
						<p className="text-xs">
							{searchTerm && sourceLabel
								? `Nenhum resultado para "${searchTerm}" em ${sourceLabel}`
								: searchTerm
									? `Nenhum resultado para "${searchTerm}"`
									: sourceLabel
										? `Nenhum item em ${sourceLabel}`
										: "Tente ajustar os filtros de busca"}
						</p>
					</>
				) : (
					<>
						<FileText className="w-12 h-12 mx-auto mb-4 opacity-50" />
						<p className="text-sm font-medium mb-2">
							Nenhum histórico disponível
						</p>
						<p className="text-xs">
							Os arquivos salvos aparecerão aqui
						</p>
					</>
				)}
			</div>
		</div>
	);
}
